import { render } from "./PatientStatements.vue?vue&type=template&id=3d0fd217"
import script from "./PatientStatements.vue?vue&type=script&lang=js"
export * from "./PatientStatements.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__